import { render, staticRenderFns } from "./Trips.vue?vue&type=template&id=3230476c&scoped=true&"
import script from "./Trips.vue?vue&type=script&lang=js&"
export * from "./Trips.vue?vue&type=script&lang=js&"
import style0 from "./Trips.vue?vue&type=style&index=0&id=3230476c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3230476c",
  null
  
)

export default component.exports